<template>
    <v-form :name="props.searchProps.formName"
            @keyup.enter="autoSearch = true">
        <Tabs value="0"
              scrollable>

            <TabList class="mb-4">
                <Tab value="0">{{ __('Basic data') }}</Tab>
            </TabList>

            <TabPanels>
                <TabPanel value="0">
                    <div class="grid">
                        <FormMultiselect fieldName="contractor_id"
                                         label="Contractor"
                                         size="12"
                                         :options="select?.contractors"
                                         v-model:field="search.contractor_id" />
                    </div>
                </TabPanel>
            </TabPanels>
        </Tabs>

        <div class="grid">
            <SearchButtons :searchProps="searchProps"
                           :search="search"
                           v-model:autoSearch="autoSearch" />
        </div>
    </v-form>
</template>

<script setup>
import { ref } from "vue";
import Tabs from 'primevue/tabs';
import TabList from 'primevue/tablist';
import Tab from 'primevue/tab';
import TabPanels from 'primevue/tabpanels';
import TabPanel from 'primevue/tabpanel';

import FormInputText from '@crud/FormInputText.vue'
import FormMultiselect from '@crud/FormMultiselect.vue'
import SearchButtons from '@crud/SearchButtons.vue'
import { prepareSearch } from '@pages/Helper/crud_utils.js'
import { __ } from '@helper/utils.js'

// -----------------------------------------------------

const props = defineProps({
    searchProps: Object,
})
const autoSearch = ref(false)

let search = ref({})

const options = ["statuses", "contractors"];
const select = ref(null);

prepareSearch(search, props, options, select)

</script>

<style lang="scss" scoped></style>
